import request from 'superagent';

const maxRetries = 3;
let retries = 0;

export function connectWebsocket(authUrl, onMessage) {
    if (typeof WebSocket === 'undefined') {
        return;
    }

    return request
        .get(authUrl)
        .then((resp) => {
            if (!resp.body || !resp.body.url) {
                throw new Error('No onsite notifications websocket URL found.');
            }
            initWebsocket(resp.body.url, authUrl, onMessage);
        })
        .catch((err) => {
            retryConnectOnFailure(authUrl, onMessage);
        });
}

function initWebsocket(websocketUrl, authUrl, onMessage) {
    const websocket = new WebSocket(websocketUrl);
    websocket.onclose = (e) => {
        retryConnect(authUrl, onMessage);
    };
    websocket.onmessage = (e) => {
        const messages = e.data.split('\n');
        for (var i = 0; i < messages.length; i++) {
            const data = JSON.parse(messages[i]);
            onMessage(data);
        }
    };
}

function retryConnectOnFailure(authUrl, onMessage) {
    if (retries >= maxRetries) {
        return;
    }
    retries += 1;
    retryConnect(authUrl, onMessage);
}

function retryConnect(authUrl, onMessage) {
    // randomise reconnect delay between 200ms -> 5000ms
    const rand = Math.round(Math.random() * (5000 - 200)) + 200;
    setTimeout(() => {
        connectWebsocket(authUrl, onMessage);
    }, rand);
}



// WEBPACK FOOTER //
// ./node_modules/@99designs/globalnav/src/actions/websocket.jsx